// @flow

import styled, { css } from 'styled-components';
import { inPixels } from '../commons/media-size';

export const CustomStyle = styled.div`
  ${props => props.value && css`

    ${props => props.to && css`
      @media (max-width: calc(${inPixels(props.to)}px - 1px)) {
        ${props.value}
      }
    `}

    ${props => props.from && css`
      @media (min-width: ${inPixels(props.from)}px) {
        ${props.value}
      }
    `}

  `}
`;
